// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3O4HG","title":"Images45_title__2nOKp","images":"Images45_images__1NuBR"};